import { fetchCategories } from "../../services/api";
import {mapGetters} from "vuex";

export default {
  namespaced: true,

  state: {
    all: [],
  },

  getters: {
    mappedById: (state) => {
      return state.all.reduce((total, category) => {
        total[category.id] = category;
        return total;
      }, {});
    },

    getAllCategories(state) {
      return state.all;
    }
  },
  actions: {
    fetch: ({ commit, rootState }) => {
      return fetchCategories(rootState.environmentId).then(({ data }) => {
        commit('SET_CATEGORIES', data);
      });
    },
  },
  mutations: {
    SET_CATEGORIES: (state, data) => {
      state.all = data;
    },
  },
};
